import { render, staticRenderFns } from "./CommentOrderModal.vue?vue&type=template&id=ac97c5dc"
import script from "./CommentOrderModal.vue?vue&type=script&lang=js"
export * from "./CommentOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports